module.exports = __webpack_public_path__ + "static/media/spinner.f32c064c.svg";